import { HubspotBrochureDownload } from '.'
import LazyLoad from 'react-lazy-load'

const VantagefitWellnessCampaigns = () => {
  return (
    <>
      <section className="homepage d-flex flex-column hero-bg position-relative vfitcompgnlogo">
        <div
          className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block heroimg"
          style={{ transform: 'translateY(70px)' }}
        >
          <div className="col-12">
            <div className="col-12">
              <img
                className="img-responsive mb-5 text-center text-lg-left"
                src="https://res.cloudinary.com/vantagecircle/image/upload/w_220/VantageFit/website/01-vantagefit-logo-2_compress.png"
                alt="Vantage Fit logo"
                width="210"
                height="43"
              />
              <h1 className="font-weight-semibold hero-heading pt-0 no-br">
                Plan Your 2025 Wellness <br />
                Journey with Ease!
              </h1>
              <p className="hero-para font-weight-semibold no-br">
                Download your{' '}
                <a
                  target="_blank"
                  style={{ color: 'orange' }}
                  href="https://try.vantagecircle.com/hubfs/Wellness%20Calendar%202025%20(1).pdf?utm_medium=button&utm_source=landingpage"
                >
                  Free Wellness Calendar
                </a>{' '}
                and take the first step <br /> towards a healthier organization
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-12 container custom_container"
          style={{ position: 'relative', zIndex: '1', transform: 'translateY(70px)' }}
        >
          <div
            className="col-12 mx-lg-4 d-flex flex-column flex-column-reverse flex-lg-row border-yn"
            style={{
              borderRadius: '20px',
              backdropFilter: 'blur(10px)',
            }}
          >
            <div className="p-4 col-12 mtb25 d-flex flex-column justify-content-start">
              <p className="hero-para font-weight-semibold no-br">
                While the calendar is a great start—Consult with our experts to <br /> design your personalized 2025
                wellness strategy!  
              </p>
              <a href="#formcont" className="vfitcompanycta mr-3 arrowbtn-img">
                Let's Talk
              </a>
            </div>
            <div className="hero-right-img1">
              <img
                className="img-responsive"
                style={{ bottom: '-50px', right: '-30px' }}
                src="https://res.cloudinary.com/vantagecircle/image/upload/v1732169482/VantageFit/2024/Hero-wellness_calendar.png"
                alt="image 1"
                width="600"
                height="541"
              />
            </div>
          </div>
        </div>
      </section>
      <section id="formcont" className="position-relative pl-0 pr-0 ">
        <div className="feat_box sect-white-col-2 shadow active_challenge features_0">
          <div className="container custom_container d-flex m-d-block justify-content-center align-items-center pt-5 mt-5">
            <div className="col-12 col-md-5">
              <div className="col-12">
                <h2 className="font-weight-semibold py-2 section-heading">Wellness Initiatives Made Simple</h2>
                <p className="section-para font-weight-normal">Get Access to : </p>
                <div>
                  <ul
                    className="greenTick position-relative"
                    style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}
                  >
                    <p className="text-white">Ready-to-use wellness calendar</p>
                  </ul>
                  <ul
                    className="greenTick position-relative"
                    style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}
                  >
                    <p className="text-white">
                      Pre-built activity templates for every month driving measurable success and impactful results
                    </p>
                  </ul>
                  <ul
                    className="greenTick position-relative"
                    style={{ minHeight: '29px', marginTop: '2.5rem', marginBottom: '2.5rem' }}
                  >
                    <p className="text-white">
                      Highly customized wellness plans that align with your organization's unique needs and goals
                    </p>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-12 col-md-6 cta-img mb-lg-0 mb-5">
              <div className="d-flex justify-content-center justify-content-lg-end">
                <div className="demo-pageform formcont">
                  <LazyLoad>
                    <HubspotBrochureDownload formID="568567fd-2abb-43a4-b030-a6e2d7875387" />
                  </LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="position-relative z1 testi-wrap pt-0 my-5">
        <div className="container custom_container px-6">
          <div className="testi-video-wrapper">
            <div className="row col-12 d-flex justify-content-between align-items-center p0">
              <div className="col-12 col-md-4 h-full p0">
                <h2 className="py-2 section-heading no-br">
                  What clients say <br />
                  about <span className="red-font">Vantage Fit</span>!
                </h2>
              </div>
              <div className="col-12 col-md-8 px-0">
                <div>
                  <LazyLoad className="pull-right1" offset={300}>
                    <iframe
                      title="Video"
                      allowFullScreen
                      frameBorder="0"
                      width="640"
                      height="360"
                      src="https://www.youtube.com/embed/5wrj6BAE5R4?si=ePh2-Xg8HHpf8UpN"
                      style={{ margin: '0', borderRadius: '22px', border: '5px solid #fff' }}
                    />
                  </LazyLoad>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="feat_box sect-white-col-2 shadow active_challenge features_0 about-pattern-vfit">
        <div className="container custom_container col-12">
          <div className="col-12 mb-5">
            <div className="col-12">
              <h2 className="font-weight-semibold py-2 section-heading no-br mb-1">
                The Ultimate Wellness Planning Tool!
              </h2>
              <p className="hero-para font-weight-semibold no-br text-white">
                Here's how our Wellness Calendar can make a difference :
              </p>
            </div>
          </div>
          <div className="row pt-4 flex-row-reverse">
            <div className="col-12 col-md-7 cta-img">
              <div className="col-12">
                <div className="d-flex justify-content-center">
                  <img
                    className="img-responsive"
                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1732169482/VantageFit/2024/Ultimate_wellness_planning_tool.png"
                    loading="lazy"
                    alt="Wellness Challenges"
                    width="550"
                    height="443"
                  />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-5">
              <div className="col-12">
                <div>
                  <div className="d-flex justify-content-start align-items-center mb-5">
                    <img
                      className="img-responsive mr-3 cmpgn-icon"
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1732169538/VantageFit/2024/hands.svg"
                      alt="icon1"
                      width="34"
                      height="34"
                    />
                    <p className="hero-para text-white font-weight-semibold no-br mb-0">
                      Pre-designed wellness activities for every day.
                    </p>
                  </div>
                  <div className="d-flex justify-content-start align-items-center mb-5">
                    <img
                      className="img-responsive mr-3 cmpgn-icon"
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360829/VantageFit/2023/Holistic.svg"
                      alt="icon2"
                      width="34"
                      height="34"
                    />
                    <p className="hero-para text-white font-weight-semibold no-br mb-0">
                      Customizable to your needs—personal or team-based.
                    </p>
                  </div>
                  <div className="d-flex justify-content-start align-items-center mb-5">
                    <img
                      className="img-responsive mr-3 cmpgn-icon"
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1699360831/VantageFit/2023/wellness_rewards.svg"
                      alt="icon3"
                      width="34"
                      height="34"
                    />
                    <p className="hero-para text-white font-weight-semibold no-br mb-0">
                      Helps you stay consistent and motivated.
                    </p>
                  </div>
                  <div className="d-flex justify-content-start align-items-center mb-5">
                    <img
                      className="img-responsive mr-3 cmpgn-icon"
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1701412165/VantageFit/2023/mental_wellbeing.svg"
                      alt="icon4"
                      width="34"
                      height="34"
                    />
                    <p className="hero-para text-white font-weight-semibold no-br mb-0">
                      A perfect balance of physical, mental, and emotional wellness.
                    </p>
                  </div>
                  <div className="d-flex justify-content-start align-items-center mb-5">
                    <img
                      className="img-responsive mr-3 cmpgn-icon"
                      src="https://res.cloudinary.com/vantagecircle/image/upload/v1732169513/VantageFit/2024/calendar.svg"
                      alt="icon5"
                      width="34"
                      height="34"
                    />
                    <p className="hero-para text-white font-weight-semibold no-br mb-0">
                      Know when you can start a wellness initiative with clear guidance.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
        <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
          <div className="col-12 border rounded-lg p-5" style={{ backdropFilter: 'blur(10px)' }}>
            <h2 className="section-heading text-center no-br">
              Ready to Build Your 2025 <br /> Wellness Strategy? 
            </h2>
            <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
              <a href="#formcont" className="vfitcompanycta arrowbtn-img pln25">
                Plan Your Wellness Roadmap
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default VantagefitWellnessCampaigns
